import { cancelRequest, request } from '../api';

export type ImageInfo = {
    id: number;
    ks3Key: string;
    url: string;
};

// 上传图片
export const uploadFile = (file: File, md5_id: string, filename: string): Promise<{ url: string; put_url: string }[]> => {
    return request({
        method: 'post',
        url: '/chat/file/gen_emu_url',
        data: [
            {
                content_type: file.type,
                md5_id,
                filename: filename,
            },
        ],
    });
};

export const uploadFileWithCancel = async (file: File, md5_id: string, filename: string): any => {
    const { axioRequest, cancelAxioRequest } = await cancelRequest({
        method: 'post',
        url: '/chat/file/gen_emu_url',
        data: [
            {
                content_type: file.type,
                md5_id,
                filename: filename,
            },
        ],
    });
    return {
        axioRequest,
        cancelAxioRequest,
    };
};
export const signatureFile = async (urlInfos: { put_url: string; url: string }[], file: File, filename: string) => {
    const requestPromise = urlInfos.map(async (userInfo: { put_url: string; url: string }) => {
        return new Promise(resolve => {
            if (!userInfo.put_url) {
                return resolve(true);
            }
            const config = {
                method: 'put',
                url: userInfo.put_url,
                headers: {
                    'x-kss-storage-class': 'STANDARD_IA',
                    'x-kss-meta-filename': filename,
                    'Content-Type': file.type,
                },
                data: file,
                onUploadProgress: function (progressEvent: { loaded: number; total: number }) {
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    if (percentCompleted === 100) {
                        resolve(true);
                    }
                },
            };
            request(config);
        });
    });
    await Promise.all(requestPromise);
};

export interface PromptParams {
    picture?: string;
    prompt: string;
    extra_prompt: string;
    ratio?: string;
    video_time: number;
}

export const enum ChatCategory {
    UP = 'up',
    DOWN = 'down',
}
export const enum ChatStatus {
    PENDING = 'processing',
    FINISH = 'finish',
    CREATE = 'create',
    FAIL = 'fail',
}
export interface ChatDetailItem {
    key: string;
    video_time: number;
    task_type: string;
    user_id: string;
    prompt: string;
    picture: string;
    video: string;
    err_msg: string;
    extra_prompt: string;
    ratio: string;
    create_time: string;
    category: string;
    status: ChatStatus;
    id: string;
    type?: string;
    src?: string;
}

export const generateResult = (data: PromptParams): Promise<ChatDetailItem> => {
    return request({
        method: 'post',
        url: '/chat/api/submit',
        data,
    }).then(res => res.data);
};

export const update_emu = async (params: { task_key: string; category: 'up' | 'down' | '' }) => {
    await request({
        method: 'post',
        url: '/chat/api/update_emu',
        params,
    });
};
export const mockResult = (task_key: string, token = 'DJOoawef8912*LKJOklajefweFJOIJO123joijF321') => {
    return request({
        method: 'post',
        url: '/chat/api/video_result',
        data: { task_key, token, err_msg: '', video: 'emu3/video/test.mp4' },
    }).then(res => res.data);
};
export const pollingResult = (task_key_list: string[]): Promise<ChatDetailItem[]> => {
    return request({
        method: 'post',
        url: '/chat/api/polling',
        data: task_key_list,
    }).then(res => res.data);
};

export const getHistory = (): Promise<ChatDetailItem[]> => {
    return request({
        method: 'post',
        url: '/chat/api/history',
    }).then(res => res.data);
};
export const delteChat = (task_key: string) => {
    return request({
        method: 'post',
        url: '/chat/api/delete',
        params: {
            task_key,
        },
    }).then(res => res.data);
};
export const getDetail = (task_key: string): Promise<ChatDetailItem[]> => {
    return request({
        method: 'post',
        url: '/chat/api/detail',
        params: {
            task_key,
        },
    }).then(res => res.data);
};

export const getPromptWord = (): Promise<string> => {
    return request({
        method: 'post',
        url: '/chat/api/prompt_list',
    });
};
